import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';
import EditAssignmentModal from './EditAssignmentModal';
import DeleteAssignmentModal from './DeleteAssignmentModal';

import { assignmentsIndex } from '../../redux/actions/assignments';

const ViewSupplierAssignments = ({ payload, activeSupplier, assignments, getAssignmentsPage, continuationToken, settings, accountUnits }) => {
  const [submitted, setSubmitted] = useState(false);
  const [activeAssignment, setActiveAssignment] = useState(null);
  const [showEditAssignmentModal, setShowEditAssignmentModal] = useState(false);
  const [showDeleteAssignmentModal, setShowDeleteAssignmentModal] = useState(false);
  const [modalY, setModalY] = useState(0);

  const [page, setPage] = useState(0);

  useEffect(() => {
    getNextAssignmentPage();
  }, []);

  const showEditModal = (event, assignment) => {
    setModalY(event.pageY);
    setActiveAssignment(assignment);
    setShowEditAssignmentModal(true);
  }

  const showDeleteModal = (event, assignment) => {
    setModalY(event.pageY);
    setActiveAssignment(assignment);
    setShowDeleteAssignmentModal(true);
  }

  const format = (value) => {
    return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  }

  const getPreviousAssignmentsPage = () => {
    let previousContinuationToken = assignments.assignmentsSearchStack[page - 2];
    getAssignmentsPage(payload, activeSupplier.id, previousContinuationToken.id, (page - 1));
    setPage(page - 1);
  }

  const getNextAssignmentPage = () => {
    getAssignmentsPage(payload, activeSupplier.id, assignments.assignmentsSearchStack[page].id, (page + 1));
    setPage(page + 1);
  }

  const itemName = (assignment) => {
    if(assignment?.product_data?.name) {
      return assignment?.product_data?.name;
    }

    if(assignment?.variation_data?.name) {
      return assignment?.variation_data?.name;
    }

    let relatedProduct = assignments.relatedProducts?.find(related => parseInt(assignment.product_id) === related.id);

    if(relatedProduct) {
      return relatedProduct.name;
    }
  }

  const itemImageUrl = (assignment) => {
    if(assignment?.product_data?.smallThumbnailUrl) {
      return assignment?.product_data?.smallThumbnailUrl;
    }

    if(assignment?.variation_data?.smallThumbnailUrl) {
      return assignment?.variation_data?.smallThumbnailUrl;
    }

    let relatedProduct = assignments.relatedProducts?.find(related => parseInt(assignment.product_id) === related.id);

    if(relatedProduct) {
      return relatedProduct.smallThumbnailUrl;
    }
  }

  return (
    <>
      
          { assignments.isFetching &&
            <div className="a-card a-card--compact">
              <div className="a-card__paddings">
                <LoadingSpinner statusText="Loading Assignments" />
              </div>
            </div>
          }

          { assignments.assignments.length === 0 && !assignments.isFetching &&
            <div className="a-card a-card--compact">
              <div className="a-card__paddings">
                <div className="text-center">
                  <p>No assignments created for this supplier. Add supplier assignments to see them listed here.</p>
                </div>
              </div>
            </div>
          }

          { assignments.assignments.length > 0 &&
            <>
              <div className="flex-container">
                <div className="flex-1">
                  <button
                    className="btn btn-default"
                    onClick={() => getPreviousAssignmentsPage()}
                    disabled={page === 1}
                  >
                    <span className="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.284 9.9992H15c.5523 0 1-.4477 1-1 0-.5522-.4477-1-1-1H5.284l2.7725-3.0035c.3746-.4059.3493-1.0385-.0565-1.4131-.4058-.3746-1.0385-.3493-1.413.0565L2.2651 8.321a1 1 0 0 0 0 1.3565l4.3217 4.6819c.3746.4058 1.0073.4311 1.4131.0565.4058-.3746.4311-1.0072.0565-1.4131L5.284 9.9992z"/></svg>
                    </span>
                    <span className="gwt-InlineLabel">Previous Assignments</span>
                  </button>

                  <button
                    className="btn btn-default"
                    onClick={() => getNextAssignmentPage()}
                    disabled={assignments.lastPage}
                  >
                    <span className="gwt-InlineLabel">Next Assignments</span>
                    <span className="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.716 9.9992H3c-.5523 0-1-.4477-1-1 0-.5522.4477-1 1-1h9.716L9.9435 4.9958c-.3746-.4059-.3493-1.0385.0565-1.4131.4058-.3746 1.0385-.3493 1.4131.0565l4.3217 4.6819a1 1 0 0 1 0 1.3565l-4.3217 4.6819c-.3746.4058-1.0073.4311-1.4131.0565-.4058-.3746-.4311-1.0072-.0565-1.4131l2.7725-3.0036z"/></svg>
                    </span>
                  </button>
                </div>
              </div>

              <div className="zebra-stripe-children">
                { assignments.assignments.map(assignment =>
                  <div className="a-card a-card--compact">
                    <div className="a-card__paddings">

                      <div className="has-hover sku-line">
                        <h4>{ assignment.variation_id ? 'Variation' : 'Product'} - { itemName(assignment) }</h4>
                        <div className="flex-container">
                          <div className="left-15">
                            { itemImageUrl(assignment) &&
                              <img src={itemImageUrl(assignment)} />
                            }
                          </div>
                        
                          <div className="flex-2">
                            <div className="left-15">
                              <h4>Assignment Details</h4>
                              <ul>
                                <li>Supplier SKU: <span className="inline-text-tag">{ assignment.supplier_sku }</span></li>
                                <li>Supplier Price: <span className="inline-text-tag">{ assignment.supplier_price ? format(assignment.supplier_price) : null }</span></li>
                                <li>Minimum Order Quantity: <span className="inline-text-tag">{ assignment.minimum_order }</span></li>
                                { settings?.settings?.order_multiples && 
                                  <li>Order Multiple: <span className="inline-text-tag">{ assignment.order_multiple }</span></li>
                                }
                                { settings?.settings?.pack_quantities && 
                                  <li>Pack Quantity: <span className="inline-text-tag">{ assignment.pack_quantity }</span></li>
                                }
                              </ul>
                            </div>
                          </div>

                          <div className="flex-2">
                            <h4>Item Details</h4>
                            { !(assignment?.variation_data || assignment?.product_data) &&
                              <>
                                <div>No matching catalog data found for this assignment.</div>
                                <div>If this item still exists in your store, this may be a temporary error. If this item has been removed from your store, you may wish to delete this assignment.</div>
                              </>
                            }

                            { (assignment?.variation_data || assignment?.product_data) &&
                              <ul>
                                { assignment?.variation_data?.options && assignment?.variation_data?.options.map(option =>
                                    <li>
                                      <strong>{ option.name }</strong>: <span className="inline-text-tag inline-text-tag--light-half">{ option.value }</span>
                                    </li>
                                  )
                                }
                                <li>
                                  Current Stock: <span className="inline-text-tag inline-text-tag--light-half">{ assignment?.product_data?.quantity || assignment?.variation_data?.quantity || 'Not Tracked' }</span>
                                </li>
                              </ul>
                            }

                          </div>


                          <div className="flex-1">
                            <div className="left-15">

                              { !(assignment?.variation_data || assignment?.product_data) &&
                                <button
                                  className={`btn btn-default btn--destructive ${assignments.updatingAssignments.find(assignmentId => assignmentId === `${assignment.product_id}/${assignment.variation_id}`) ? 'btn-loading' : ''}`}
                                  onClick={(event) => showDeleteModal(event, assignment)}
                                  disabled={submitted || assignments.updatingAssignments.find(assignmentId => assignmentId === `${assignment.product_id}/${assignment.variation_id}`)}
                                >
                                  Remove Assignment
                                </button>
                              }

                              { (assignment?.variation_data || assignment?.product_data) &&
                                <>
                                  <button
                                    className={`btn btn-default ${assignments.updatingAssignments.find(assignmentId => assignmentId === `${assignment.product_id}/${assignment.variation_id}`) ? 'btn-loading' : ''}`}
                                    onClick={(event) => showEditModal(event, assignment)}
                                    disabled={submitted || assignments.updatingAssignments.find(assignmentId => assignmentId === `${assignment.product_id}/${assignment.variation_id}`)}
                                  >
                                    <span className="svg-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M5.0355 15.7929 2.207 12.9645 1.5 16.5l3.5355-.7071z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8136.9437c.3906-.3905 1.0237-.3905 1.4143 0l2.8284 2.8284c.3905.3905.3905 1.0237 0 1.4142L5.5285 16.7141.2252 17.7748l1.0606-5.3033L12.8136.9437zm.7072 2.1213-9.8995 9.8995 1.4142 1.4142 9.8995-9.8995-1.4142-1.4142zM3.0071 15.1788l-.186-.186-.0464.2325.2324-.0465z"/></svg>
                                    </span>
                                    <span className="gwt-InlineLabel">Edit Assignment</span>
                                  </button>
                                  <br/>
                                  <br/>
                                  <button
                                    className={`btn btn-default btn--destructive ${assignments.updatingAssignments.find(assignmentId => assignmentId === `${assignment.product_id}/${assignment.variation_id}`) ? 'btn-loading' : ''}`}
                                    onClick={(event) => showDeleteModal(event, assignment)}
                                    disabled={submitted || assignments.updatingAssignments.find(assignmentId => assignmentId === `${assignment.product_id}/${assignment.variation_id}`)}
                                  >
                                    <span className="svg-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M7 0h4l1 2H6l1-2z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3c-.5523 0-1 .4477-1 1s.4477 1 1 1v11c0 1.1046.8954 2 2 2h10c1.1046 0 2-.8954 2-2V5c.5523 0 1-.4477 1-1s-.4477-1-1-1H2zm12 13V5H4v11h10z"/><path d="M6 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6zM10 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6z"/></svg>
                                    </span>
                                    <span className="gwt-InlineLabel">Remove Assignment</span>
                                  </button>
                                </>
                              }
                            </div>
                          </div>

                        </div>

                        
                      </div>
                    </div>
                  </div>
                )}
                
              </div>
            </>
          }
        

      { showEditAssignmentModal && 
        <EditAssignmentModal
          payload={payload}
          supplierId={activeSupplier.id}
          showEditAssignmentModal={showEditAssignmentModal}
          setShowEditAssignmentModal={setShowEditAssignmentModal}
          assignment={activeAssignment}
          assignmentName={itemName(activeAssignment)}
          modalY={modalY}
        />
      }

      { showDeleteAssignmentModal &&
        <DeleteAssignmentModal
          payload={payload}
          supplierId={activeSupplier.id}
          showDeleteAssignmentModal={showDeleteAssignmentModal}
          setShowDeleteAssignmentModal={setShowDeleteAssignmentModal}
          assignment={activeAssignment}
          assignmentName={itemName(activeAssignment)}
          modalY={modalY}
        />
      }
    </>
  )

}

const mapStateToProps = state => ({
  accountUnits: state.accounts.account.store_details.formatsAndUnits,
  assignments: state.assignments,
  continuationToken: state.assignments.assignments?.continuationToken,
  settings: state.settings
});

const mapDispatchToProps = (dispatch) => ({
  getAssignmentsPage: (payload, supplierId, continuationToken, page) => dispatch(assignmentsIndex(payload, supplierId, continuationToken, page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewSupplierAssignments);